// src/components/DiscordLoginButton.js

import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { ReactComponent as DiscordLogo } from '../assets/discord_logo.svg'; // Ensure the path is correct

const FlashyButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(135deg, #9AC0CD 0%, #A1D1F0 100%)', // Gradient background
  borderRadius: '50%', // Circular shape
  padding: '12px', // Adjust padding for size
  minWidth: '60px',
  minHeight: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  boxShadow: '0 4px 10px rgba(154, 192, 205, 0.4)',
  '&:hover': {
    transform: 'scale(1.1)',
    boxShadow: '0 6px 15px rgba(161, 209, 240, 0.6)',
    background: 'linear-gradient(135deg, #A1D1F0 0%, #9AC0CD 100%)', // Reverse gradient on hover
  },
}));

const DiscordLogoStyled = styled(DiscordLogo)(({ theme }) => ({
  width: '24px',
  height: '24px',
  fill: '#fff', // Ensure the logo color contrasts with the button
}));

const DiscordLoginButton = () => {
  const handleDiscordLogin = () => {
    const clientId = process.env.REACT_APP_DISCORD_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_DISCORD_REDIRECT_URI_ADMIN; // Use admin redirect URI
    const responseType = 'code';
    const scope = 'identify guilds';
    const state = 'admin'; // Optional: can be used to maintain state between request and callback

    if (!redirectUri) {
      console.error('DiscordLoginButton: REACT_APP_DISCORD_REDIRECT_URI_ADMIN is not defined.');
      return;
    }

    const discordAuthURL = `https://discord.com/api/oauth2/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&response_type=${responseType}&scope=${encodeURIComponent(scope)}&state=${state}`;

    // Redirect to Discord OAuth2
    window.location.href = discordAuthURL;
  };

  return (
    <FlashyButton onClick={handleDiscordLogin} aria-label="Login with Discord">
      <DiscordLogoStyled />
    </FlashyButton>
  );
};

export default DiscordLoginButton;

